import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./state/store";

import "./global";

import "./filters/index";
import "./plugins/index";

import "./assets/css/app.css";
import "./assets/css/open-sans-font.css";

Vue.config.productionTip = process.env.NODE_ENV !== "production";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
